/**
* 图表界面
*/
<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding: 20px;" class="home-head">
      <el-row :gutter="23"  style="display: flex;align-items: center;">
        <el-col :span="18" style="font-size: 20px;">
          概况
        </el-col>

        <el-col :span="18" style="font-size: 20px;">
          展会
          <el-select v-model="formInline.exhibitionId" placeholder="请选择"  style="height: 33px;width: 250px;">
            <el-option
              v-for="item in exhList"
              :key="item.id"
              :label="item.exhibitionName"
              :value="item.id"  @click.native="selectExhId(item.id)">
            </el-option>
          </el-select>
        </el-col>


      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="24" style="margin-top: 20px;">
        <el-col :span="4">
          <el-card class="box-card" style="background-color:#68C089;color:white">
            <el-row style="text-align: center">
              <div>
                使用展会数
              </div>
              <div>
                 {{countOk}}
              </div>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="4">
          <el-card class="box-card" style="background-color:#A67FCD;color:white">
            <el-row style="text-align: center">
              <div>
                预约申请中
              </div>
              <div>
                {{countYyz}}
              </div>
            </el-row>
          </el-card>
        </el-col>


        <el-col :span="4">
          <el-card class="box-card" style="background-color:#EAB377;color:white">
            <el-row style="text-align: center">
              <div>
                总预约数
              </div>
              <div>
                {{count}}
              </div>
            </el-row>
          </el-card>
        </el-col>

      </el-row>


      <el-row >
        <el-col :span="23" style="margin-top: 50px">
          <el-divider></el-divider>
        </el-col>
      </el-row>


      <el-row :gutter="24" style="margin-top: 20px;">

      </el-row>
      <el-col :span="4">
        <el-card class="box-card" style="background-color:#7FA1E0;color:white;">
          <el-row style="text-align: center">
            <div>
              订单量
            </div>
            <div>
              {{countOrder}}
            </div>
          </el-row>
        </el-card>
      </el-col>

      <el-col :span="4">
        <el-card class="box-card" style="background-color:#68C089;color:white;margin-left: 20px;">
          <el-row style="text-align: center">
            <div>
              销售额（元）
            </div>
            <div>
              ￥{{countCash}}
            </div>
          </el-row>
        </el-card>
      </el-col>
      <el-row>
        <el-col :span="23" style="margin-top: 20px">
          <template>
            <el-tabs v-model="graphName" style="margin-bottom: 100px; width: 100%" type="border-card" @tab-click="handleClick">
              <el-tab-pane label="数据图" name="coinRanking" style="width: 100%">
                <el-button @click="submitForm('1')">今天</el-button><el-button @click="submitForm('3')">本月</el-button>
                <el-button @click="submitForm('5')" style="margin-right:20px;">年</el-button>
                <span style="margin-right:20px;">日期范围 :</span><el-date-picker style="height: 40px;width: 300px;margin-right:20px;"  v-model="times" type="daterange" @change="dataPicker" start-placeholder="开始日期"end-placeholder="结束日期"></el-date-picker>
                <div class="st-gbox">
                  <div class="cavasbox" ref="COINchart"></div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-col>
      </el-row>
      <br/>




    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Chart from 'echarts'
import {qryStatistics,qryGraph} from '../../api/statisticsApi'
import {timestampToTime,parseTime} from "../../utils/util";
import ElRow from "element-ui/packages/row/src/row";
import ElCol from "element-ui/packages/col/src/col";
import {qryExhibitionList} from "../../api/courseApi";
export default {
  name: "welcome",
  data() {
    return {
      times:'',
      count:'',
      countOk:'',
      countYyz:'',
      countOrder:'',
      countCash:'',
      graphName:'coinRanking',
      listData:[],
      exhList:[],
      formInline:{
        exhibitionId:'',
        beginTime : '',
        endTime :'',
      },
      graphForm:{
        beginTime : '',
        endTime :'',
        type:1,
      },
      graph :{
        title: {
          text: 'Stacked Line'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['Email']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['2021-12-08', '2021-12-09', '2021-12-10', '2021-12-11', '2021-12-14']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'Email',
            type: 'line',
            stack: 'Total',
            data: [9, 83, 37, 60, 24]
          },
        ]
      },
    }
  },
  // 导入组件
  components: {
    ElCol,
    ElRow
    // 点聚合组件
  },
  // 创建完毕状态(里面是操作)
  created() { },
  // 挂载结束状态(里面是操作)
  mounted() {
    this.qryStatistics();
    this.qryGraph();
  },
  // 里面的函数只有调用才会执行
  methods: {
    submitForm(value){
      this.graphForm.type=value;
      this.qryGraph();
    },
    qryStatistics(){
      qryStatistics(this.formInline).then(res => {
        this.count = res.data.count;
        this.countOk = res.data.countOk;
        this.countYyz = res.data.countYyz;
        this.countOrder = res.data.countOrder;
        this.countCash = res.data.countCash;
      })

      qryExhibitionList({pageSize:1000}).then(res => {
        this.exhList = res.data.list;
        this.exhList.unshift({id:'',exhibitionName:'全部'})
      })
    },

    qryGraph(){
      qryGraph(this.graphForm).then(res => {
        this.graph.title.text =res.data.title
        this.graph.legend.data=res.data.legend
        this.graph.xAxis.data = res.data.timeList;
        this.graph.series=res.data.seriesList;
        this.chart = Chart.init(this.$refs.COINchart)
        this.chart.setOption(this.graph)


      })
    },

    dataPicker(value) {
      if (value != null) {
        this.graphForm.beginTime = parseTime(
          value[0],
          "{y}-{m}-{d}"
        );
        this.graphForm.endTime = parseTime(value[1], "{y}-{m}-{d}");
      } else {
        this.graphForm.beginTime = "";
        this.graphForm.endTime = "";
      }
      if(this.graphForm.beginTime!="" &&  this.graphForm.endTime!=""){
        this.graphForm.type=6;
        this.formInline.beginTime = this.graphForm.beginTime;
        this.formInline.endTime = this.graphForm.endTime;
        this.qryGraph();
        this.qryStatistics();
      }
    },

    selectExhId(e){
      this.formInline.exhibitionId = e;
      this.qryStatistics();
    },

    handleClick(){
      this.qryGraph();
    },



  }
};
</script>
<style>
.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.st-gbox {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 5px;
  height: 30vh;
  box-sizing: border-box;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/statistics.vue